<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        lg="3"
        class="mt-3"
      >
        <base-card>
          <v-card-title class="flex-column">
            <v-avatar class="my-4">
              <v-img
                src="@/assets/images/file_upload_icon.png"
                alt=""
              />
            </v-avatar>
            <p class="ma-0 text-body-1 text-gray-500">
              Media Sources
            </p>
            <v-btn
              depressed
              color="primary"
              @click="goToNewAutoSource"
            >
              + add
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-list subheader>
              <v-list-item-group
                v-model="selectedType"
                color="primary"
              >
                <v-subheader>TYPES</v-subheader>

                <v-list-item
                  v-for="(type, i) in importTypes"
                  :key="i"
                >
                  <v-list-item-avatar>
                    <v-icon v-text="type.icon" />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ type.text }} ({{ type.count }})
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>

            <!--v-divider />

            <v-list
              disabled
              dense
              two-line
            >
              <v-subheader
                class="text--disabled font-weight-medium text-uppercase pl-2"
              >
                storage
              </v-subheader>
              <v-list-item-group
                color="primary"
              >
                <v-list-item class="ma-0">
                  <v-list-item-icon class="mr-1 pt-4">
                    <v-icon>mdi-floppy</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      class="font-weight-medium"
                    >
                      2 Gb used of 30 GB
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <v-progress-linear
                        value="80"
                        class="w-24"
                      />
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list-->
          </v-card-text>
        </base-card>
      </v-col>
      <v-col
        cols="12"
        lg="9"
      >
        <v-row>
          <v-col
            v-if="!mediaSources.length && !loading"
            md="12"
            class="text-center ma-5 font-weight-bold"
          >
            <h6>No data</h6>
          </v-col>
          <v-col
            v-for="source in mediaSources"
            :key="source.id"
            cols="12"
            lg="12"
          >
            <base-card>
              <v-card-text>
                <v-row>
                  <v-col
                    md="6"
                    class="pl-3 pb-0"
                  >
                    <div class="flex-1 d-flex align-center mr-4">
                      <v-avatar tile>
                        <v-icon
                          class="mr-3"
                          large
                          :color="source.iconColor"
                          v-text="source.icon"
                        />
                      </v-avatar>
                      <div class="flex-grow-1">
                        <p class="font-weight-semi ma-0 ">
                          {{ source.name }}
                        </p>
                        <span class="text--disabled">
                          {{ source.url }}
                        </span>
                      </div>
                    </div>
                  </v-col>
                  <v-col
                    md="4"
                    class="pb-0"
                  >
                    <div
                      v-if="source.totalItemCount"
                      class="d-flex justify-space-between"
                    >
                      <p
                        class="ma-0"
                      >
                        <span class="mr-2">
                          <v-icon
                            class="pr-1"
                            x-small
                            :color="source.processedItemCount > 0 ? 'primary' : 'grey'"
                          >mdi-circle</v-icon>In Progress ({{ source.processedItemCount }})
                        </span>
                        <span>
                          <v-icon
                            x-small
                            class="pr-1"
                            :color="source.totalItemCount - source.processedItemCount > 0 ? 'success' : 'grey'"
                          >mdi-circle</v-icon>Processed ({{ source.totalItemCount - source.processedItemCount }})
                        </span>
                      </p>
                    </div>
                    <v-progress-linear
                      v-if="source.totalItemCount"
                      :value="progressbarValue(source)"
                      :background-color="source.totalItemCount > 0 ? 'success' : 'grey'"
                      color="primary"
                      rounded
                    />
                  </v-col>
                  <v-col
                    md="2"
                    class="pr-5 pb-0 text-right"
                  >
                    <p class="ma-0">
                      <span
                        v-if="getSourceState(source) === 'off'"
                        class="font-weight-medium grey--text"
                      >
                        <v-icon
                          color="secondary"
                          class="mr-2"
                        >mdi-minus-circle</v-icon>Off
                      </span>
                      <span
                        v-else-if="getSourceState(source) === 'ok'"
                        class="font-weight-medium grey--text"
                      >
                        <v-icon
                          color="success"
                          class="mr-2"
                        >mdi-check</v-icon>On
                      </span>
                      <span
                        v-else
                        class="font-weight-medium grey--text"
                      >
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              color="error"
                              class="mr-2"
                              v-on="on"
                            >fas fa-exclamation-triangle</v-icon>
                          </template>
                          {{ source.error }}
                        </v-tooltip>

                      </span>
                    </p>
                  </v-col>
                  <v-col
                    md="12"
                    class="pt-0 pb-0"
                  >
                    <v-divider class="pt-0 pb-0" />
                    <div class="d-flex justify-space-between align-center flex-wrap">
                      <small class="text--disabled">
                        Imported {{ moment.utc(source.lastImportTime).from(moment().utc()) }}
                      </small>
                      <div>
                        <v-btn
                          depressed
                          small
                          @click="goToSource(source)"
                        >
                          Details
                        </v-btn>
                        <v-menu
                          bottom
                          left
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>

                          <v-list>
                            <v-list-item
                              @click="goToEditSource(source)"
                            >
                              <v-list-item-title>
                                Edit
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>
                                Disable
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              @click="openMediaSourceRemoveDialog(source)"
                            >
                              <v-list-item-title>
                                Delete
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </base-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!--section class="au-breadcrumb2">
      <div class="container m-b-60">
        <div class="row m-b-10">
          <div class="col-md-9 m-t-50">
            <h3 class="text-h6">
              <i class="fas fa-list p-r-5" />
              Recent Uploads
            </h3>
          </div>
          <div class="col-md-3 text-right m-t-50">
            <v-btn
              small
              color="secondary"
              @click="goToAssetList()"
            >
              Show all
            </v-btn>
          </div>
        </div>
        <v-card :loading="loading">
          <table class="table table-data2 table-assets">
            <tbody>
              <template v-for="(asset, i) of assets">
                <tr
                  :key="asset.id"
                  class="tr-shadow text--pointer"
                  @click="goToAsset(asset)"
                  @mouseover="setActiveRow3(i)"
                  @mouseleave="setActiveRow3(-1)"
                >
                  <td style="width: 200px;">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span
                          class="block-email lighten-4"
                          v-on="on"
                        >
                          {{ asset.mediaSource.name | truncate(20) }}
                        </span>
                      </template>
                      <span>Source: {{ asset.mediaSource.name || 'N/A' }}</span>
                    </v-tooltip>
                  </td>
                  <td style="width: 180px;">
                    {{ moment(asset.createTime).utc().format('MMM D, YYYY HH:mm') }}
                  </td>
                  <td>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ asset.name || 'n/a' }}</span>
                      </template>
                      {{ asset.name }}
                    </v-tooltip>
                  </td>
                  <td
                    style="width: 150px;"
                    class="text-body-1"
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <div
                          class="status text-body-1 tc-green-900 bgc-green-100 m-r-5"
                          v-on="on"
                        >
                          C
                        </div>
                      </template>
                      Created
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <div
                          class="status text-body-1  tc-red-600 bgc-red-100"
                          :class="{
                            'tc-green-900 bgc-green-100': ['ready'].includes(asset.state),
                            'tc-amber-800 transcoding-pulse-animation': ['transcoding'].includes(asset.state),
                            'no-padding': asset.state === 'error',
                          }"
                          v-on="on"
                        >
                          <span v-if="asset.state === 'error'">
                            <i class="mdi mdi-alert-outline" />
                          </span>
                          <span v-else>T</span>
                        </div>
                      </template>
                      Transcoded
                    </v-tooltip>
                  </td>
                  <td style="width: 100px;">
                    <div class="table-data-feature p-r-20">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            text
                            icon
                            class="m-0 item"
                            :color="activeRow3 === i ? 'light-blue lighten-1': ''"
                            v-on="on"
                            @click.stop="goToEditAsset(asset)"
                          >
                            <i class="zmdi zmdi-edit" />
                          </v-btn>
                        </template>
                        <span>Edit</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
                <tr
                  :key="asset.id+'spacer'"
                  class="spacer"
                />
              </template>
              <template v-if="!assets.length && !loading">
                <tr class="tr-shadow">
                  <td
                    colspan="5"
                    class="text-center"
                  >
                    No data
                  </td>
                </tr>
                <tr class="spacer" />
              </template>
            </tbody>
          </table>
        </v-card>
      </div>
    </section-->

    <!-- Import Remove Dialog -->
    <v-dialog
      v-model="removeDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Delete media source?
        </v-card-title>
        <v-card-text>
          <div class="row p-b-20">
            <div class="col-md-12">
              Are you sure you want to delete the source "{{ deletedSource.name }}"?
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            text
            @click="removeDialog = false"
          >
            No
          </v-btn>
          <v-btn
            depressed
            color="error"
            @click="deleteSource()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { processAsset, processMediaSource } from '@/store/converters'

  export default {
    data () {
      return {
        selectedType: 0,
        importTypes: [
          { text: 'All', type: 'all', icon: 'mdi-format-list-bulleted', count: 0 },
          { text: 'FTP', type: 'ftp', icon: 'mdi-folder', count: 0 },
          { text: 'AWS', type: 'aws', icon: 'mdi-aws', count: 0 },
          { text: 'Watchfolder', type: 'ftp-watchfolder', icon: 'mdi-folder-clock', count: 0 },
          { text: 'mRSS', type: 'mrss', icon: 'mdi-rss-box', count: 0 },
        ],
        channel: {},
        assets: [],
        activeRow: -1,
        activeRow3: -1,
        allMediaSources: [],
        mediaSources: [{}],
        deletedSource: {},
        removeDialog: false,
        mediaSourceMap: {},
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
    },
    watch: {
      selectedType (newVal) {
        const selectedType = this.importTypes[newVal]
        if (selectedType.type === 'all') {
          this.mediaSources = JSON.parse(JSON.stringify(this.allMediaSources))
          return
        }
        const filtered = []
        for (let i = 0; i < this.allMediaSources.length; i += 1) {
          if (this.allMediaSources[i].type === selectedType.type) {
            filtered.push(this.allMediaSources[i])
          }
        }
        this.mediaSources = filtered
      },
    },
    created () {
      this.channel.id = this.$route.params.id
      this.loadData()
    },
    methods: {
      progressbarValue (source) {
        if (source.totalItemCount > 0) {
          return source.processedItemCount * 100 / source.totalItemCount
        }
        return 0
      },
      loadData () {
        this.$store.commit('setPageLoader')

        const args = {
          $expand: 'tags',
          $orderby: '-id',
          'channel.id[eq]': this.channel.id,
        }

        const mediaSourcesReq = this.$store.dispatch('mediaSources', args)

        return Promise.all([mediaSourcesReq])
          .then((res) => {
            const mediaSources = res[0]
            const processed = mediaSources.map((s) => processMediaSource(s))
            const typeCount = {}
            for (let i = 0; i < processed.length; i += 1) {
              const source = processed[i]
              if (source.type === 'mrss2') {
                source.type = 'mrss'
                source.state = source.state2
                source.lastImportTime = source.lastImportTime2
              }
              if (source.type === 'mrss') {
                source.icon = 'mdi-rss-box'
                source.iconColor = 'orange'
              } else if (source.type === 'ftp') {
                source.icon = 'mdi-folder'
                source.iconColor = 'primary'
              } else if (source.type === 'aws') {
                source.icon = 'mdi-aws'
                source.iconColor = 'orange darken-2'
              } else if (source.type === 'ftp-watchfolder') {
                source.icon = 'mdi-folder-clock'
                source.iconColor = 'primary darken-2'
              }
              source.subTitle = source.category === 'automatic' ? 'auto upload' : 'manual upload'

              // eslint-disable-next-line no-prototype-builtins
              if (!typeCount.hasOwnProperty(processed[i].type)) {
                typeCount[source.type] = 0
              }
              typeCount[source.type] += 1
            }
            this.mediaSources = processed
            this.allMediaSources = JSON.parse(JSON.stringify(processed))

            this.importTypes[0].count = this.mediaSources.length
            for (let i = 0; i < this.importTypes.length; i += 1) {
              // eslint-disable-next-line no-prototype-builtins
              if (typeCount.hasOwnProperty(this.importTypes[i].type)) {
                this.importTypes[i].count = typeCount[this.importTypes[i].type]
              }
            }
            this.getStat()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      getStat () {
        const ids = []
        for (let i = 0; i < this.mediaSources.length; i += 1) {
          ids.push(this.mediaSources[i].id)
        }
        if (ids.length === 0) return

        const args = {
          id: ids.join(','),
        }

        const statsReq = this.$store.dispatch('mediaSourcesStat', args)
        return Promise.all([statsReq])
          .then((res) => {
            const stats = res[0]
            if (stats && stats.length) {
              for (let i = 0; i < stats.length; i += 1) {
                const stat = stats[i]
                for (let j = 0; j < this.mediaSources.length; j += 1) {
                  if (this.mediaSources[j].id === stat.source_id) {
                    this.mediaSources[j].totalItemCount = stat.in_progress + stat.completed
                    this.mediaSources[j].processedItemCount = stat.in_progress
                    break
                  }
                }
              }
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
      },
      getSourceState (source) {
        if (!source.active) {
          return 'off'
        }
        if (source.type === 'ftp' || source.type === 'ftp-watchfolder') {
          if (source.state2 === 'ok' || source.state2 === 'processing') {
            return 'ok'
          }
        } else {
          if (source.state === 'success' || source.state === 'processing' || source.state === 'ok') {
            return 'ok'
          }
        }
        return 'error'
      },
      setActiveRow3 (i) {
        this.activeRow3 = i
      },
      goToManualSource (source) {
        return
        // eslint-disable-next-line no-unreachable
        this.$router.push({
          name: 'ManualSourceDetailPage',
          params: {
            source_id: source.id,
          },
        })
      },
      goToSource (source) {
        if (source.type === 'ftp' || source.type === 'ftp-watchfolder') {
          this.$router.push({
            name: 'SourceDetailPage',
            params: {
              source_id: source.id,
            },
          })
          return
        }

        if (source.category !== 'automatic') return
        this.$router.push({
          name: 'AutoSourceDetailPage',
          params: {
            source_id: source.id,
          },
        })
      },
      goToNewManualSource () {
        return
        // eslint-disable-next-line no-unreachable
        this.$router.push({
          name: 'EditManualSourcePage',
        })
      },
      goToNewAutoSource () {
        this.$router.push({
          name: 'AutoSourceNewPage',
        })
      },
      goToEditManualSource (source) {
        this.$router.push({
          name: 'EditManualSourcePage',
          params: {
            source_id: source.id,
          },
        })
      },
      goToEditSource (source) {
        this.$router.push({
          name: 'AutoSourceEditPage',
          params: {
            source_id: source.id,
          },
        })
      },
      goToAsset (asset) {
        this.$router.push({
          name: 'AssetDetailPage',
          params: {
            asset_id: asset.id,
          },
        })
      },
      goToAssetList () {
        this.$router.push({
          name: 'AssetListPage',
        })
      },
      goToEditAsset (asset) {
        this.$router.push({
          name: 'AssetEditPage',
          params: {
            id: this.channel.id,
            asset_id: asset.id,
          },
        })
      },
      openMediaSourceRemoveDialog (source) {
        this.deletedSource = Vue.util.extend({}, source)
        this.removeDialog = true
      },
      deleteSource () {
        if (!this.deletedSource) return

        this.$store.commit('setPageLoader')

        this.$store.dispatch('deleteMediaSource', this.deletedSource.id)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The media source has been successfully removed',
              timeout: 6000,
              color: 'success',
            })
            this.loadData()
            this.deletedSource = {}
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          // eslint-disable-next-line no-return-assign
          .finally(() => this.removeDialog = false)
      },
    },
  }
</script>
